// DennikKatalogTab.jsx — Nastavenia firmy › Denník — katalóg  (DENNIK_TUK_V1, 21. 10. 2026)
// ZADANIE MIRKA (ksbx-appky 2846, 2849): „office mení sady v Nastaveniach firmy“ — pribudne práca = office ju pridá, appka sa nemení.
// Jeden katalóg (ústava 0.J, 4, 25.2) = inspection_presets: práce podľa remesla skupiny Rozpisu, prestoje, kontroly majstra.
// Office píše po slovensky; preklady (sq, uk, pl, en, ru, cs) doplní Claude sám a dajú sa opraviť ručne (ústava 6).
// Nič sa nemaže — položka sa vypne (66.7). Zmeny idú do auditu (kto, čo, kedy). Stráž neuložených zmien (53.1.b).
import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { COLORS, TYPO, SPACE, RADIUS, hladaj } from '../theme.js'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from './Toast.jsx'
import { useDirtyFlag } from '../hooks/useDirtyState.js'
import NavIcon from './NavIcon.jsx'

const JAZYK = { sq: 'Albánsky', uk: 'Ukrajinsky', pl: 'Poľsky', en: 'Anglicky', ru: 'Rusky', cs: 'Česky' }
const IKONY = ['', 'naradie', 'metla', 'partie', 'kluc', 'plu', 'vozidla', 'stena', 'iskra', 'okno', 'roh', 'kvapka', 'sokel', 'vrstvy', 'vlna',
  'stierka', 'valcek', 'folia', 'kladivo', 'kos', 'kuzel', 'zamestnanci', 'nastav', 'teplomer', 'presyp', 'ok', 'fotky', 'alert']
const inp = { width: '100%', padding: '6px 9px', border: `1px solid ${COLORS.line}`, borderRadius: 6, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box', background: COLORS.bg }
const lbl = { fontSize: 11, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 3 }
const karta = { background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: SPACE.md, marginBottom: 12 }
const btn = (c, plny) => ({ padding: '5px 11px', border: `1px solid ${c}`, background: plny ? c : COLORS.bg, color: plny ? '#fff' : c, borderRadius: 6, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' })

const SADY_NA_COM = ['omietky_cement', 'omietky_sadra', 'malby']
function pluNazov(plu, ref) {
  const m = String(ref || '').match(/^plu:(.+)$/); if (!m) return String(ref || '').startsWith('qc:') ? 'položka katalógu poterov' : ''
  const x = (plu || []).find(p => String(p.plu) === m[1]); return x ? x.name : 'PLU ' + m[1] + ' v registri nie je'
}

export default function DennikKatalogTab() {
  const toast = useToast()
  const [d, setD] = useState(null)
  const [zmeny, setZmeny] = useState({})          // id → rozpísané polia
  const [otvorene, setOtvorene] = useState({})    // id → jazyky rozbalené
  const [nove, setNove] = useState({})            // druh|sada → text
  const [hladat, setHladat] = useState('')
  const [druh, setDruh] = useState('praca')
  const [busy, setBusy] = useState(false)
  const [plu, setPlu] = useState([])               // register materiálov (PLU) na odkaz pri „S čím“
  useEffect(() => { fetchAuth('/api/plu-catalog').then(r => r.ok ? r.json() : []).then(d => setPlu(Array.isArray(d) ? d : (d.rows || []))).catch(() => {}) }, [])

  const load = useCallback(() => {
    fetchAuth('/api/diary/katalog/sprava').then(async r => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || 'HTTP ' + r.status); return j })
      .then(setD).catch(e => { toast.error('Katalóg sa nenačítal: ' + e.message); setD({ polozky: [], druhy: [], zavinil: [] }) })
  }, [toast])
  useEffect(() => { load() }, [load])

  const dirty = Object.keys(zmeny).length > 0
  // stráž odchodu: „Uložiť“ je úspešné len vtedy, keď sa uložila každá rozpísaná položka
  const ulozVsetko = async () => { let ok = true; for (const id of Object.keys(zmeny)) ok = (await uloz(Number(id))) && ok; return ok }
  useDirtyFlag(dirty, { key: 'nastavenia-dennik-katalog', save: ulozVsetko, discard: () => setZmeny({}) })

  const hodnota = (r, k) => (zmeny[r.id] && zmeny[r.id][k] !== undefined) ? zmeny[r.id][k] : r[k]
  const zmen = (r, k, v) => setZmeny(z => ({ ...z, [r.id]: { ...(z[r.id] || {}), [k]: v } }))
  // posiela sa len ten jazyk, ktorý office opravil (ostatné sa pri zmene slovenského textu preložia samy)
  const zmenPreklad = (r, l, k, v) => setZmeny(z => {
    const cur = { ...((z[r.id] && z[r.id].preklady) || {}) }
    cur[l] = { ...(cur[l] || {}), [k]: v }
    return { ...z, [r.id]: { ...(z[r.id] || {}), preklady: cur } }
  })
  const zlucPreklady = (r) => { const o = JSON.parse(JSON.stringify(r.preklady || {})); const z = (zmeny[r.id] && zmeny[r.id].preklady) || {}
    for (const l of Object.keys(z)) o[l] = { ...(o[l] || {}), ...z[l] }; return o }
  async function uloz(id) {
    const telo = zmeny[id]; if (!telo) return true
    setBusy(true)
    try {
      const r = await fetchAuth('/api/diary/katalog/polozka/' + id, { method: 'PUT', body: JSON.stringify(telo) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || 'HTTP ' + r.status)
      setZmeny(z => { const x = { ...z }; delete x[id]; return x })
      toast.success(j.preklad && j.preklad.ok === false ? 'Uložené. Preklad sa nepodaril — doplň ho ručne alebo skús Preložiť.' : 'Uložené.')
      load()
      return true
    } catch (e) { toast.error('Neuložené: ' + e.message); return false }
    finally { setBusy(false) }
  }
  async function prepniAktivnu(r) {
    setBusy(true)
    try {
      const x = await fetchAuth('/api/diary/katalog/polozka/' + r.id, { method: 'PUT', body: JSON.stringify({ active: r.active ? 0 : 1 }) })
      if (!x.ok) throw new Error('HTTP ' + x.status)
      toast.success(r.active ? 'Vypnuté — v appke sa už neukáže (nič sa nezmazalo).' : 'Zapnuté.'); load()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) } finally { setBusy(false) }
  }
  async function prelozit(r) {
    setBusy(true)
    try {
      const x = await fetchAuth('/api/diary/katalog/polozka/' + r.id + '/prelozit', { method: 'POST', body: '{}' })
      const j = await x.json().catch(() => ({}))
      if (!x.ok) throw new Error(j.error || 'HTTP ' + x.status)
      toast.success('Preložené do 6 jazykov.'); load()
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  async function pridaj(dr, sada) {
    const text = String(nove[dr + '|' + sada] || '').trim(); if (!text) { toast.error('Napíš názov položky.'); return }
    setBusy(true)
    try {
      const x = await fetchAuth('/api/diary/katalog/polozka', { method: 'POST', body: JSON.stringify({ druh: dr, sada, text }) })
      const j = await x.json().catch(() => ({}))
      if (!x.ok) throw new Error(j.error || 'HTTP ' + x.status)
      setNove(n => ({ ...n, [dr + '|' + sada]: '' }))
      toast.success(j.preklad && j.preklad.ok ? 'Pridané a preložené.' : 'Pridané. Preklad sa doplní neskôr alebo ručne.'); load()
    } catch (e) { toast.error('Nepridané: ' + e.message) } finally { setBusy(false) }
  }
  async function posun(zoznam, i, smer) {   // poradie sa počíta z celej sady, aj keď je zapnuté hľadanie
    const j = i + smer; if (j < 0 || j >= zoznam.length) return
    const r1 = zoznam[i], r2 = zoznam[j]
    const cela = (d?.polozky || []).filter(r => r.druh === r1.druh && r.sada === r1.sada)
    const ids = cela.map(r => r.id); const a = ids.indexOf(r1.id), b = ids.indexOf(r2.id); if (a < 0 || b < 0) return
    ;[ids[a], ids[b]] = [ids[b], ids[a]]
    try { const x = await fetchAuth('/api/diary/katalog/poradie', { method: 'PUT', body: JSON.stringify({ ids }) }); if (!x.ok) throw new Error('HTTP ' + x.status); load() }
    catch (e) { toast.error('Poradie sa neuložilo: ' + e.message) }
  }

  const druhy = d?.druhy || []
  const aktDruh = druhy.find(x => x.druh === druh) || druhy[0]
  const polozky = useMemo(() => (d?.polozky || []).filter(r => !hladat.trim() || hladaj(r.text + ' ' + (r.popis || '') + ' ' + Object.values(r.preklady || {}).map(x => x.text || '').join(' '), hladat)), [d, hladat])
  if (!d) return <div style={{ color: COLORS.muted }}>Načítavam…</div>

  return (
    <div style={{ maxWidth: 1000 }}>
      <datalist id="dk_plu">{plu.slice(0, 400).map(p => <option key={p.plu} value={'plu:' + p.plu}>{p.name}</option>)}</datalist>
      <div style={{ fontSize: 13, color: COLORS.muted, marginBottom: 10, lineHeight: 1.5 }}>
        Dlaždice Denníka na ťuk v mview, v appke MATRIX Stavba (iOS aj Android). Človek vidí <b>Pre všetkých</b> + sadu svojho remesla
        (skupina v dnešnom Rozpise, inak skupina z karty zamestnanca); ostatné remeslá sú pod „+ Robil som aj iné remeslo“.
        Píš po slovensky — preklady do 6 jazykov sa doplnia samy a dajú sa opraviť. Do denníka sa zapisuje vždy po slovensky.
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
        {druhy.map(x => (
          <button key={x.druh} type="button" onClick={() => setDruh(x.druh)} style={btn(COLORS.nav, druh === x.druh)}>
            {x.nazov} · {(d.polozky || []).filter(r => r.druh === x.druh && r.active).length}
          </button>
        ))}
        <span style={{ flex: 1 }} />
        <input type="search" placeholder="Hľadať položku…" value={hladat} onChange={e => setHladat(e.target.value)} style={{ ...inp, width: 220 }} />
        {dirty && <button type="button" disabled={busy} onClick={ulozVsetko} style={btn(COLORS.add, true)}>Uložiť všetko ({Object.keys(zmeny).length})</button>}
      </div>

      {(aktDruh?.sady || []).map(s => {
        const zoznam = polozky.filter(r => r.druh === aktDruh.druh && r.sada === s.sada)
        return (
          <div key={s.sada} style={karta}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>{s.nazov}</div>
              {s.skupiny && s.skupiny.length > 0 && <div style={{ fontSize: 12, color: COLORS.muted }}>skupiny Rozpisu: {s.skupiny.join(', ')}</div>}
              <span style={{ flex: 1 }} />
              <span style={{ fontSize: 12, color: COLORS.muted }}>{zoznam.filter(r => r.active).length} zapnutých</span>
            </div>
            {zoznam.length === 0 && <div style={{ fontSize: 13, color: COLORS.muted, padding: '4px 0 8px' }}>Zatiaľ prázdne — pridaj prvú položku nižšie.</div>}
            {zoznam.map((r, i) => {
              const zm = !!zmeny[r.id]
              const prek = zlucPreklady(r)
              const pocetPrekladov = Object.keys(JAZYK).filter(l => prek[l] && prek[l].text).length
              return (
                <div key={r.id} style={{ border: `1px solid ${zm ? COLORS.nav : COLORS.lineSoft}`, background: r.active ? COLORS.bg : COLORS.bgSoft, borderRadius: 8, padding: 8, marginBottom: 6, opacity: r.active ? 1 : 0.65 }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <button type="button" title="Vyššie" onClick={() => posun(zoznam, i, -1)} style={{ ...btn(COLORS.muted), padding: '0 6px' }}>↑</button>
                      <button type="button" title="Nižšie" onClick={() => posun(zoznam, i, 1)} style={{ ...btn(COLORS.muted), padding: '0 6px' }}>↓</button>
                    </div>
                    <span style={{ width: 28, display: 'flex', justifyContent: 'center', color: COLORS.nav }}>{hodnota(r, 'ikona') ? <NavIcon name={hodnota(r, 'ikona')} size={20} /> : null}</span>
                    <div style={{ flex: 2, minWidth: 180 }}>
                      <div style={lbl}>Text (SK)</div>
                      <input value={hodnota(r, 'text')} onChange={e => zmen(r, 'text', e.target.value)} style={{ ...inp, fontWeight: 700 }} />
                    </div>
                    <div style={{ flex: 1.4, minWidth: 140 }}>
                      <div style={lbl}>Popis pod textom</div>
                      <input value={hodnota(r, 'popis') || ''} placeholder="napr. EPS, fólia, dilatácia" onChange={e => zmen(r, 'popis', e.target.value)} style={inp} />
                    </div>
                    {['praca', 'prestoj'].includes(aktDruh.druh) && (
                      <div style={{ width: 130 }}>
                        <div style={lbl}>Ikona</div>
                        <select value={hodnota(r, 'ikona') || ''} onChange={e => zmen(r, 'ikona', e.target.value)} style={inp}>
                          {IKONY.map(k => <option key={k} value={k}>{k || '— bez ikony —'}</option>)}
                        </select>
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: 6, alignItems: 'flex-end', marginLeft: 'auto' }}>
                      <button type="button" onClick={() => setOtvorene(o => ({ ...o, [r.id]: !o[r.id] }))} style={btn(COLORS.nav)}>Jazyky {pocetPrekladov}/6</button>
                      <button type="button" onClick={() => prepniAktivnu(r)} disabled={busy} style={btn(r.active ? COLORS.remove : COLORS.add)}>{r.active ? 'Vypnúť' : 'Zapnúť'}</button>
                      {zm && <button type="button" disabled={busy} onClick={() => uloz(r.id)} style={btn(COLORS.add, true)}>Uložiť</button>}
                    </div>
                  </div>
                  {aktDruh.druh === 'praca' && SADY_NA_COM.includes(r.sada) && (
                    <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13, fontWeight: 600, marginTop: 6, paddingLeft: 66 }}>
                      <input type="checkbox" checked={!!hodnota(r, 'na_com')} onChange={e => zmen(r, 'na_com', e.target.checked ? 1 : 0)} /> pýtať sa „Na čom“ (strop, steny, špalety)
                    </label>
                  )}
                  {aktDruh.druh === 'material' && (
                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', marginTop: 6, paddingLeft: 66 }}>
                      <div style={{ flex: 1.2, minWidth: 160 }}>
                        <div style={lbl}>Do denníka (celý názov)</div>
                        <input value={hodnota(r, 'veta') || ''} placeholder={hodnota(r, 'text')} onChange={e => zmen(r, 'veta', e.target.value)} style={inp} />
                      </div>
                      <div style={{ flex: 1.4, minWidth: 200 }}>
                        <div style={lbl}>Odkaz do registra (PLU)</div>
                        <input list="dk_plu" value={hodnota(r, 'material_ref') || ''} placeholder="plu:5001 — prázdne, kým PLU nie je" onChange={e => zmen(r, 'material_ref', e.target.value.trim())} style={inp} />
                        <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>{pluNazov(plu, hodnota(r, 'material_ref'))}</div>
                      </div>
                      <div style={{ flex: 1.4, minWidth: 200 }}>
                        <div style={lbl}>Ponúknuť len pri prácach (prázdne = pri každej)</div>
                        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>{(d.polozky || []).filter(x => x.druh === 'praca' && x.sada === r.sada).map(x => {
                          const v = hodnota(r, 'vazba') || []; const on = v.includes(x.kluc)
                          return <button key={x.kluc} type="button" onClick={() => zmen(r, 'vazba', on ? v.filter(k => k !== x.kluc) : [...v, x.kluc])} style={btn(on ? COLORS.nav : COLORS.muted, on)}>{x.text}</button>
                        })}</div>
                      </div>
                    </div>
                  )}
                  {aktDruh.druh === 'prestoj' && (
                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', marginTop: 6, paddingLeft: 66 }}>
                      <div style={{ flex: 1.4, minWidth: 160 }}>
                        <div style={lbl}>Veta do denníka</div>
                        <input value={hodnota(r, 'veta') || ''} placeholder="napr. neporiadok na stavbe" onChange={e => zmen(r, 'veta', e.target.value)} style={inp} />
                      </div>
                      <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13, fontWeight: 600, paddingBottom: 6 }}>
                        <input type="checkbox" checked={!!hodnota(r, 'fotka_povinna')} onChange={e => zmen(r, 'fotka_povinna', e.target.checked ? 1 : 0)} /> fotka povinná
                      </label>
                      {!!hodnota(r, 'fotka_povinna') && (
                        <div style={{ flex: 1, minWidth: 150 }}>
                          <div style={lbl}>Čo odfotiť (do „Chýba: …“)</div>
                          <input value={hodnota(r, 'fotka_text') || ''} placeholder="napr. fotka neporiadku" onChange={e => zmen(r, 'fotka_text', e.target.value)} style={inp} />
                        </div>
                      )}
                      <div style={{ width: 170 }}>
                        <div style={lbl}>Kto zavinil — predvolené</div>
                        <select value={hodnota(r, 'kto_zavinil') || ''} onChange={e => zmen(r, 'kto_zavinil', e.target.value)} style={inp}>
                          <option value="">— nevybrané —</option>
                          {(d.zavinil || []).map(z => <option key={z.kluc} value={z.kluc}>{z.text}</option>)}
                        </select>
                      </div>
                    </div>
                  )}
                  {otvorene[r.id] && (
                    <div style={{ marginTop: 8, paddingLeft: 66 }}>
                      {Object.keys(JAZYK).map(l => (
                        <div key={l} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                          <span style={{ width: 90, fontSize: 12, color: COLORS.muted, fontWeight: 600 }}>{JAZYK[l]}{prek[l] && prek[l].auto ? ' · auto' : ''}</span>
                          <input value={(prek[l] && prek[l].text) || ''} placeholder={hodnota(r, 'text')} onChange={e => zmenPreklad(r, l, 'text', e.target.value)} style={{ ...inp, flex: 2 }} />
                          {(hodnota(r, 'popis') || (prek[l] && prek[l].popis)) && <input value={(prek[l] && prek[l].popis) || ''} placeholder={hodnota(r, 'popis') || 'popis'} onChange={e => zmenPreklad(r, l, 'popis', e.target.value)} style={{ ...inp, flex: 1.4 }} />}
                          {!!hodnota(r, 'fotka_povinna') && <input value={(prek[l] && prek[l].fotka_text) || ''} placeholder={hodnota(r, 'fotka_text') || 'čo odfotiť'} onChange={e => zmenPreklad(r, l, 'fotka_text', e.target.value)} style={{ ...inp, flex: 1 }} />}
                        </div>
                      ))}
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 4 }}>
                        <button type="button" disabled={busy} onClick={() => prelozit(r)} style={btn(COLORS.nav)}>Preložiť znova (Claude)</button>
                        <span style={{ fontSize: 11, color: COLORS.muted }}>Naposledy: {r.updated_by || '—'} · {String(r.updated_at || '').slice(0, 16).replace('T', ' ')}</span>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <input value={nove[aktDruh.druh + '|' + s.sada] || ''} placeholder={'+ Nová položka do „' + s.nazov + '“ (po slovensky)'}
                onChange={e => setNove(n => ({ ...n, [aktDruh.druh + '|' + s.sada]: e.target.value }))}
                onKeyDown={e => { if (e.key === 'Enter') pridaj(aktDruh.druh, s.sada) }} style={{ ...inp, flex: 1 }} />
              <button type="button" disabled={busy} onClick={() => pridaj(aktDruh.druh, s.sada)} style={btn(COLORS.add, true)}>Pridať</button>
            </div>
          </div>
        )
      })}
    </div>
  )
}
